import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomFormFieldCheckboxBoolean = ({
  disabled,
  formField,
  onChange,
  value = false
}) => {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const isError = showAllErrors && formField.required && !value;
  const fieldLabel = formField.label;
  const errorKey = `empty${fieldLabel}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    dispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: fieldLabel
      }
    }));
  }, [isError, dispatch, fieldLabel, errorKey]);
  return /*#__PURE__*/_jsx(FormControl, {
    help: formField.description,
    required: formField.required,
    error: isError,
    validationMessage: isError && errorMessage,
    paddingBlockStart: "100",
    children: /*#__PURE__*/_jsxs(Checkbox, {
      color: "icon-interactive-default",
      "data-test-id": "custom-form-field-checkbox-input-single",
      checked: Boolean(value),
      paddingBlockStart: "200",
      disabled: disabled,
      onChange: event => onChange(syntheticEvent(event.target.checked)),
      children: [formField.label, formField.required && /*#__PURE__*/_jsx("span", {
        children: " * "
      })]
    })
  });
};
export default CustomFormFieldCheckboxBoolean;